/**
 * orga-app-api - veranstaltungstypen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VeranstaltungsTypDetail { 
    anzeige_feld_1?: string;
    anzeige_feld_2?: string;
    anzeige_feld_3?: string;
    beginn_text?: string;
    beobachter_text?: string;
    bezeichnung?: string;
    einlass_text?: string;
    ist_aktionen_sichtbar?: boolean;
    ist_auswahl_nur_diensthabende?: boolean;
    ist_beginn_sichtbar?: boolean;
    ist_beobachter_sichtbar_report?: boolean;
    ist_deaktiviert?: boolean;
    ist_einlass_sichtbar?: boolean;
    ist_fb_admin_zugriff?: boolean;
    ist_veranstaltungsleitung_sichtbar?: boolean;
    ist_veranstaltungsleitung_sichtbar_report?: boolean;
    veranstaltungsleiter_text?: string;
    veranstaltungstyp_id: string;
    ist_aufgabe_neutral_text_optional?: boolean;
    ist_aufgabe_nichtok_text_optional?: boolean;
}

